import { Component } from '@angular/core';

export type Lang = 'en' | 'es';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css']
})
export class ServicesComponent {

  isNavOpen = false;
  lang: Lang = 'en';

  setLang(l: Lang) {
    this.lang = l;
  }

  get t() {
    return this.translations[this.lang];
  }

  translations = {
    en: {
      nav: {
        login: 'LOGIN',
        register: 'REGISTER NOW',
      },
      hero: {
        badge: 'Directory, Marketing & Business Growth Services',
        title: 'Our Services',
        subtitle: 'From directory profile setup to full-service digital marketing — premium add-ons crafted for agents, creators, and growing businesses inside the UMYO Español Directory.'
      },
      tabs: {
        listing: 'Listing Setup',
        property: 'Property Listings',
        social: 'Social & Content',
        marketing: 'Marketing & SEO',
        crm: 'CRM Integrations',
        leads: 'Lead Generation',
        webapp: 'Web & App',
        platforms: 'Platforms'
      },
      footer: {
        tagline: 'FOR US. BY US. POWERED BY UMYO.',
        quickLinks: 'QUICK LINKS',
        resources: 'RESOURCES',
        connect: 'LET\'S CONNECT',
        copyright: '© 2026 UMYO Español Directory. All Rights Reserved.'
      }
    },
    es: {
      nav: {
        login: 'INICIAR SESIÓN',
        register: 'REGISTRARSE AHORA',
      },
      hero: {
        badge: 'Servicios de Directorio, Marketing y Crecimiento Empresarial',
        title: 'Nuestros Servicios',
        subtitle: 'Desde la configuración del perfil del directorio hasta el marketing digital de servicio completo — complementos premium diseñados para agentes, creadores y empresas en crecimiento dentro del Directorio UMYO Español.'
      },
      tabs: {
        listing: 'Configuración de Listado',
        property: 'Listados de Propiedades',
        social: 'Social y Contenido',
        marketing: 'Marketing y SEO',
        crm: 'Integraciones CRM',
        leads: 'Generación de Leads',
        webapp: 'Web y App',
        platforms: 'Plataformas'
      },
      footer: {
        tagline: 'PARA NOSOTROS. POR NOSOTROS. POTENCIADO POR UMYO.',
        quickLinks: 'ENLACES RÁPIDOS',
        resources: 'RECURSOS',
        connect: 'CONECTEMOS',
        copyright: '© 2026 Directorio UMYO Español. Todos los derechos reservados.'
      }
    }
  };
}